import * as React from "react";
const SvgCircularEuroActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#circularEuroActive_svg__a)">
      <path
        fill="#fff"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m.244 5.001a3.298 3.298 0 0 0-2.584 5.346H8.113a.625.625 0 0 0 0 1.25h2.226c-.545 1.013-1.226 1.846-2.004 2.21a.626.626 0 0 0 .265 1.191h5.837q.053-.004.143-.012c.117-.01.28-.032.464-.075.36-.084.858-.261 1.271-.647a.626.626 0 0 0-.853-.914c-.193.18-.456.286-.702.343a2.3 2.3 0 0 1-.376.055H10.38c.557-.637 1.004-1.403 1.353-2.151h1.725a.626.626 0 0 0 0-1.25h-1.215a2.048 2.048 0 1 1 2.048-2.048.625.625 0 1 0 1.25 0A3.3 3.3 0 0 0 12.244 7"
      />
    </g>
    <defs>
      <clipPath id="circularEuroActive_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCircularEuroActive;
